import { render, staticRenderFns } from "./Slick2.vue?vue&type=template&id=032028fc&scoped=true&"
import script from "./Slick2.vue?vue&type=script&lang=js&"
export * from "./Slick2.vue?vue&type=script&lang=js&"
import style0 from "./Slick2.vue?vue&type=style&index=0&id=032028fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032028fc",
  null
  
)

export default component.exports